import {
  trackProductError,
  trackProductEvent,
  type ProductBaseProperties,
} from "./product";

export const FINANCIAL_FLOW = "financial";

export type FinancialEventName =
  | "financial_navigation_clicked"
  | "financial_account_create_submit_attempt"
  | "financial_account_created"
  | "financial_account_create_error"
  | "financial_account_update_submit_attempt"
  | "financial_account_updated"
  | "financial_account_update_error"
  | "financial_transaction_create_submit_attempt"
  | "financial_transaction_created"
  | "financial_transaction_create_error"
  | "financial_income_update_submit_attempt"
  | "financial_income_updated"
  | "financial_income_update_error"
  | "financial_outcome_update_submit_attempt"
  | "financial_outcome_updated"
  | "financial_outcome_update_error"
  | "financial_monthly_fee_update_submit_attempt"
  | "financial_monthly_fee_updated"
  | "financial_monthly_fee_update_error"
  | "financial_monthly_fee_payment_reviewed"
  | "financial_monthly_fee_reminder_sent"
  | "financial_settlement_updated"
  | "financial_settlement_update_error"
  | "financial_transparency_submit_attempt"
  | "financial_transparency_updated"
  | "financial_transparency_error"
  | "financial_form_chat_started"
  | "financial_form_chat_field_collected"
  | "financial_form_chat_completed"
  | "financial_form_chat_submit_error";

export const trackFinancialEvent = (
  event: FinancialEventName,
  baseProperties: ProductBaseProperties,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductEvent(event, baseProperties, eventProperties, FINANCIAL_FLOW);
};

export const trackFinancialError = (
  event: FinancialEventName,
  baseProperties: Omit<ProductBaseProperties, "success" | "errorCode">,
  error: unknown,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductError(
    event,
    baseProperties,
    error,
    eventProperties,
    FINANCIAL_FLOW,
  );
};
